import FeedOutlined from '@mui/icons-material/FeedOutlined';
import { Box, IconButton, Typography } from '@/shared/ui';

import type { RelatedCode } from '@/features/factsheet';
import { useIsFactsheetCompact } from '@/features/factsheet/state/useIsFactsheetCompact';

const RelatedCodeItem = ({
  relatedCode,
  openNewTab
}: {
  relatedCode: RelatedCode;
  openNewTab: (code: string) => void;
}) => {
  const isCompact = useIsFactsheetCompact();
  return (
    <Box sx={{ pb: 1, display: 'flex', alignItems: 'center' }}>
      <IconButton
        sx={{ width: 28, height: 28, mr: 0.5 }}
        onClick={() => {
          openNewTab(relatedCode.code);
        }}
      >
        <FeedOutlined sx={{ fontSize: isCompact ? 14 : 16 }} />
      </IconButton>
      <Typography
        size={isCompact ? 14 : undefined}
        sx={{ fontWeight: 700, mr: 2 }}
      >
        {relatedCode.code}
      </Typography>
      <Typography size={isCompact ? 14 : undefined}>{relatedCode.title}</Typography>
    </Box>
  );
};

export default RelatedCodeItem;
